import axios from 'axios';

import {
  JustificativaStatus,
  ProtocoloExecutado,
  ProtocoloExecutadoResumo,
} from '@/models/ProtocoloExecutado';

import api from '@/sevices/api';
import { AbrirProtocoloPayload, ExecutarPassoPayload } from '../types';

async function criarExecucaoByCodigo({
  codigoProtocolo,
}: AbrirProtocoloPayload): Promise<ProtocoloExecutado> {
  return (
    await api.post<ProtocoloExecutado>(
      `/runtime/protocolos/${codigoProtocolo}/abrir/`,
      {},
    )
  ).data;
}

async function getExecucaoResumo(
  sessionId: string,
  execucaoId: string,
): Promise<ProtocoloExecutadoResumo> {
  const execucao = (
    await api.get<ProtocoloExecutadoResumo>(
      `/runtime/${sessionId}/protocolos-executados/${execucaoId}/resumo/`,
    )
  ).data;
  return execucao;
}

async function executarPasso({
  passoExecutado,
  respostas,
}: ExecutarPassoPayload): Promise<ProtocoloExecutado> {
  const protocolo = (
    await api.put<ProtocoloExecutado>(
      `/runtime/${passoExecutado.session_id}/passos-executados/${passoExecutado.id}/`,
      respostas,
    )
  ).data;
  return protocolo;
}

async function cancelarExecucao(
  protocolo: ProtocoloExecutado,
): Promise<boolean> {
  if (protocolo.status === 'CANCELADO') {
    return false;
  }

  try {
    await api.post<ProtocoloExecutado>(
      `/runtime/${protocolo.session_id}/protocolos-executados/${protocolo.id}/cancelar/`,
    );
    return true;
  } catch {
    return false;
  }
}

function cancelarExecucaoSilently(protocolo: ProtocoloExecutado): boolean {
  if (navigator.sendBeacon && protocolo.status !== 'CANCELADO') {
    const baseURL = process.env.REACT_APP_API_URL;
    return navigator.sendBeacon(
      `${baseURL}/runtime/${protocolo.session_id}/protocolos-executados/${protocolo.id}/cancelar/`,
    );
  }

  return false;
}

async function justificarStatusProtocolo(
  sessionId: string,
  execucaoId: string,
  justificativa: { texto?: string; modelo?: number },
): Promise<JustificativaStatus | null> {
  try {
    const { modelo, texto } = justificativa;

    const { justificativa_status } = (
      await api.post<{ justificativa_status: JustificativaStatus }>(
        `/runtime/${sessionId}/protocolos-executados/${execucaoId}/justificativas/`,
        {
          modelo,
          texto,
        },
      )
    ).data;

    return justificativa_status;
  } catch (err) {
    // Ignora erros de requisição ou servidor p/ não bloquear usuário e evitar
    // cláusulas try/cacth dentro de componentes sem necessidade
    if (axios.isAxiosError(err)) {
      return null;
    }

    throw err;
  }
}

async function pausarExecucao(
  protocolo: ProtocoloExecutado,
): Promise<ProtocoloExecutado> {
  return (
    await api.post<ProtocoloExecutado>(
      `/runtime/${protocolo.session_id}/protocolos-executados/${protocolo.id}/pausar/`,
      {},
    )
  ).data;
}

export default {
  criarExecucaoByCodigo,
  getExecucaoResumo,
  executarPasso,
  cancelarExecucao,
  cancelarExecucaoSilently,
  justificarStatusProtocolo,
  pausarExecucao,
};
